import { useEffect, useState } from "react"
import Input from "../../Input"
import { toast } from "react-toastify"

const AutoRank = ({ values, serverData }) => {
    const [ranks, setRanks] = useState([])
    const [isFormOpen, setIsFormOpen] = useState(false)
    const [editingIndex, setEditingIndex] = useState(null)
    const [formRankName, setFormRankName] = useState("")
    const [formSgID, setFormSgID] = useState("")

    useEffect(() => {
        if (!values) return
        if (values?.ranks) {
            try {
                const parsed = Array.isArray(values.ranks) ? values.ranks : JSON.parse(values.ranks)
                setRanks(parsed || [])
            } catch (err) {
                setRanks(values.ranks || [])
            }
        }
    }, [values])

    const resetForm = () => {
        setFormRankName("")
        setFormSgID("")
        setEditingIndex(null)
    }

    const openAddForm = () => {
        resetForm()
        setIsFormOpen(true)
    }

    const openEditForm = (index) => {
        const item = ranks[index]
        setIsFormOpen(true)
        setFormRankName(item.rankName)
        setFormSgID(item.sgID)
        setEditingIndex(index)
    }

    const cancelForm = () => {
        setIsFormOpen(false)
        resetForm()
    }

    const handleAdd = () => {
        const rankName = (formRankName || "").trim()
        const sgID = (formSgID || "").toString().trim()
        if (!rankName || !sgID) {
            toast.error("لطفا مقادیر خواسته شده را وارد کنید")
            return
        }
        if (ranks.find((r) => r.rankName === rankName)) {
            toast.error("رنک با این نام قبلا توسط شما اضافه شده است")
            return
        }
        setRanks((prev) => [...(prev || []), { rankName, sgID }])
        setIsFormOpen(false)
        resetForm()
    }

    const handleEdit = () => {
        const rankName = (formRankName || "").trim()
        const sgID = (formSgID || "").toString().trim()
        if (!rankName || !sgID) {
            toast.error("لطفا مقادیر خواسته شده را وارد کنید")
            return
        }
        const nameTakenByOther = ranks.some((r, i) => i !== editingIndex && r.rankName === rankName)
        if (nameTakenByOther) {
            toast.error("رنک با این نام قبلا توسط شما اضافه شده است")
            return
        }
        setRanks((prev) => {
            const next = [...prev]
            next[editingIndex] = { rankName, sgID }
            return next
        })
        setIsFormOpen(false)
        resetForm()
    }

    const handleDelete = () => {
        setRanks((prev) => prev.filter((_, i) => i !== editingIndex))
        setIsFormOpen(false)
        resetForm()
    }

    return (
        <div className="mx-14 h-full">
            <input name="autoRank-ranks" className="hidden" value={JSON.stringify(ranks || [])} readOnly />
            <h6 className="flex justify-center">رنک اتومات</h6>
            <div className="font-sans">
                <Input
                    type="text"
                    label="ایدی رنک هایی که میتوانند از این استفاده کنند:(با , میتوانید چند تا رنک وارد کنید و برای اینکه همه استفاده کنند خالی بزارین) *"
                    name="autoRank-canUseIds"
                    options={serverData?.sgList}
                    multi={true}
                    placeholder="کسانی که میتوانند از این آپشن استفاده کنند"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.canUseIds}
                />
            </div>
            <div className="font-sans">
                <Input
                    type="text"
                    label="پیامی که وقتی کلاینت بیش از ده رنک به خودش اد میکنه فرستاده بشه"
                    name="autoRank-maxMsg"
                    placeholder="Message"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.maxMsg}
                />
            </div>
            <div className="mt-2">
                <div className="flex flex-wrap w-full">
                    {ranks?.map((item, index) => (
                        <div key={index}>
                            <span role="button" className="text-blue-400" onClick={() => openEditForm(index)}>
                                {item.rankName}{" "}
                            </span>
                            ,
                        </div>
                    ))}
                    <button type="button" className="px-2 bg-gray-700 rounded-md" onClick={openAddForm}>
                        Add
                    </button>
                </div>
                {isFormOpen && (
                    <div className="flex justify-between place-items-center gap-5">
                        <div className="flex gap-5">
                            <div>
                                <Input
                                    type="text"
                                    label="اسم رنک"
                                    placeholder="rankName"
                                    autoComplete="off"
                                    dir="ltr"
                                    value={formRankName}
                                    onChange={(e) => setFormRankName(e.target.value)}
                                />
                            </div>
                            <div>
                                <Input
                                    type="number"
                                    options={serverData?.sgList}
                                    label="ایدی رنک"
                                    placeholder="sgID"
                                    autoComplete="off"
                                    dir="ltr"
                                    value={formSgID}
                                    onChange={(v) => setFormSgID(v)}
                                />
                            </div>
                        </div>
                        {editingIndex === null ? (
                            <div className="flex gap-2">
                                <button
                                    type="button"
                                    className="styled-button px-2 success justify-item-center mt-5 border-none"
                                    onClick={handleAdd}
                                >
                                    اضافه
                                </button>
                                <button
                                    type="button"
                                    className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                                    onClick={cancelForm}
                                >
                                    بیخیال
                                </button>
                            </div>
                        ) : (
                            <div className="flex gap-2">
                                <button
                                    type="button"
                                    className="styled-button px-2 success justify-item-center mt-5 border-none"
                                    onClick={handleEdit}
                                >
                                    ویرایش
                                </button>
                                <button
                                    type="button"
                                    className="styled-button px-2 danger justify-item-center mt-5 border-none"
                                    onClick={handleDelete}
                                >
                                    حذف
                                </button>
                                <button
                                    type="button"
                                    className="styled-button px-2 bg-gray-500 hover:bg-gray-600 justify-item-center mt-5 border-none"
                                    onClick={cancelForm}
                                >
                                    بیخیال
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div className="mt-2">
                <label for="" class="block">
                    پیام اختصاصی
                </label>
                <textarea
                    type="text"
                    row="2"
                    name="autoRank-msgFormat"
                    class="styled-input"
                    placeholder="پیامی که هرموقع کاربر از کامند لیست استفاده کرد ارسال بشه"
                    autoComplete="off"
                    defaultValue={values?.msgFormat}
                    dir="ltr"
                />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr" className="text-green-300">
                    <div>%name: اسم کاربر</div>
                </div>
                <span>این بات به کاربران امکان مدیریت آسان رنک‌ها را می‌دهد: </span>
                <br />
                <br />
                <div className="flex justify-between">
                    <span>با دستور روبه رو پیام تعریف شده به کاربر ارسال میشود:</span>
                    <span dir="ltr" className="text-green-300">
                        !rank list
                    </span>
                </div>
                <div className="flex justify-between">
                    <span>با دستور روبه رو رنک مورد نظر خود را اضافه کنید:</span>
                    <span dir="ltr" className="text-green-300">
                        !rank add rankName{" "}
                    </span>
                </div>
                <div className="flex justify-between">
                    <span>با دستور روبه رو رنک مورد نظر خود را حذف کنید:</span>
                    <span dir="ltr" className="text-green-300">
                        !rank remove rankName{" "}
                    </span>
                </div>{" "}
            </div>
        </div>
    )
}

export default AutoRank
